import { FundingRequestComponentTypeEnumGQLType } from '../../../types/dashboard-core-gqlTypes.generated.d';

export const fundingRequestKeyToLabel: {
  [key in FundingRequestComponentTypeEnumGQLType]: string;
} = {
  collectionsPaydown: 'Collections paydown',
  collectionsRecycle: 'Collections recycle',
  curePaydown: 'Cure paydown',
  drawRequest: 'Credit facility draw',
};

export const fundingRequestKeyToVerb: {
  [key in FundingRequestComponentTypeEnumGQLType]: string;
} = {
  collectionsPaydown: 'collections paydown',
  collectionsRecycle: 'collections recycle',
  curePaydown: 'cure paydown',
  drawRequest: 'credit facility draw',
};
